import React from 'react'

const Advisor1 = () => {
  return (
<section className="w-full">
  {/* Full Background Image Section */}
  <div
    className="w-full h-[850px] bg-cover "
    style={{
      backgroundImage:
        "url('https://res.cloudinary.com/dzngpgki4/image/upload/v1744985725/image-3_jwiu2t.png')",
    }}
  ></div>

  {/* Box below the image */}
  <div
    className="w-full h-[223px] bg-[#152C24] rounded-b-[5px] md:px-20 md:pt-5 md:pb-5" 
  >
    <h1 className='text-white font-medium md:text-[48px]'>
    VUYO NCWAIBA 
    </h1>
    <h1 className='text-white font-extrabold md:text-[64px] md:mt-1'>
    Advisor - Enterprise development
    </h1>
  </div>

  {/* Paragraph Section */}
  <div className="w-full bg-[#2E453D] px-6 md:px-20 py-16">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">

  <p className="md:mb-10 mb-5">
    Vuyo Ncwaiba<br/>
    Enterprise and Supplier Development Specialist
  </p>

  <p className="md:mb-10 mb-5">
    Founder and CEO at VuMaLi Consulting
  </p>

  <p className="md:mb-10 mb-5">
    Specialist in optimising socio-economic and enterprise development spend within organizations,<br/>
    by linking it to profitability and sustainability.<br/><br/>
    This is a two-fold process: ensuring enterprise development is sustainable and profitable for organizations<br/>
    in the long term and ensuring SME's are transaction ready. In turn, this opens up the value chains of<br/>
    corporates for small medium sized enterprises.<br/><br/>
    Vuyo’s deep desire is to make a meaningful impact that changes lives, economies, and the status quo,<br/>
    while still providing value for corporates. She strives to empower the community and the economy.
  </p>

  <p className="md:mt-16 mt-5 mb-5">
    Chairperson of the Board<br/>
    Lithemba Mining, South Africa
  </p>

  <p className="md:mt-16 mt-5 mb-5">
    Consultant<br/>
    UN Women · Contract UN Women
  </p>

  <p className="md:mt-16 mb-5">
    Chapter Director East London<br/>
    Startup Grind
  </p>

  <p className="md:mt-16 mb-5">
    Part-Time Member<br/>
    International Trade Administration Commission of South Africa (ITAC)
  </p>

  <p className="md:mt-16 mb-5">
    Non Executive Director<br/>
    e-Waste Association of South Africa
  </p>

  <p className="md:mt-16 mt-10">
    Treasurer and Founding Member<br/>
    Enterprise Development Council Of South Africa
  </p>

</div>

  <div className='md:mt-40 mt-10'></div>
</div>

  </div>
</section>

  )
}

export default Advisor1